import globalStyles from '../../styles/global.module.css';
import styles from './styles.module.css';

interface CognitiveAbilitiesCategoryProps {
    title: string;
    description: string;
    icon: any;
}

const CognitiveAbilitiesCategory = (props: CognitiveAbilitiesCategoryProps) => {
    const { icon, title, description } = props;

    return (
        <div className={styles.cognitiveAbilitiesCategories}>
            <div className={styles.cognitiveAbilitiesCategoriesIconContainer}>
                <img src={icon} alt={`${title} icon`} />
            </div>
            <div
                className={`${styles.cognitiveAbilitiesCategoriesExplanation}`}>
                <p
                    className={`${globalStyles.text} ${globalStyles.textBold} ${globalStyles.textNoBelowSpace}`}>
                    {title}
                </p>
                <p
                    className={`${globalStyles.text} ${globalStyles.textNoAboveSpace} ${globalStyles.textNoBelowSpace}`}>
                    {description}
                </p>
            </div>
        </div>
    );
};

export default CognitiveAbilitiesCategory;
